<template>
  <div class="d-flex">
    <span v-if="isDelivery && category.minimumDeliveryQuantity > 0" class="grey--text ">
      Cantidad mínima: {{ category.minimumDeliveryQuantity }}
    </span>
    <span
        v-if="isTakeAway && category.minimumTakeAwayQuantity > 0 " class="grey--text ">
        Cantidad mínima: {{ category.minimumTakeAwayQuantity }}
    </span>
    <v-spacer></v-spacer>
    <span
        v-if="isDelivery && category.minimumDeliveryQuantity > 0 && categoryQuantity > 0"
        class="grey--text "
    >
      {{ categoryQuantity }}/{{ category.minimumDeliveryQuantity }}
    </span>

    <span
        v-if="isTakeAway && category.minimumTakeAwayQuantity > 0 && categoryQuantity > 0"
        class="grey--text "
    >
      {{ categoryQuantity }}/{{ category.minimumTakeAwayQuantity }}
    </span>

  </div>

</template>

<script>
export default {
  name: "CustomerCategoryQuantity",
  props: {
    category: {type: Object, required: true},
  },
  computed: {
    isDelivery() {
      return this.$store.getters.orderSystem.order.isDelivery
    },
    isTakeAway() {
      return this.$store.getters.orderSystem.order.isTakeAway
    },
    categoryQuantity() {
      return this.$store.getters.orderSystem.cartService.getQuantityByCategory(this.category)
    }
  }
}
</script>

<style scoped>

</style>
